import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

const appState = (state: RootState) => state.app;

const selectSideMenuCollapsed = createSelector(
  appState,
  (state) => state.sideMenuCollapsed,
);

const selectChatWidgetVisibility = createSelector(
  appState,
  (state) => state.chatWidgetVisible,
);

const floatingTodayTasksVisible = createSelector(
  appState,
  (state) => state.floatingTodayTasksVisible,
);

const selectSearchResults = createSelector(
  appState,
  (state) => state.searchResults?.results || [],
);

const selectSearchLoading = createSelector(
  appState,
  (state) => state.searchLoading,
);

const selectSearchOptions = createSelector(
  appState,
  (state) => state.searchOptions,
);

export const appSliceSelectors = {
  selectSideMenuCollapsed,
  selectChatWidgetVisibility,
  floatingTodayTasksVisible,
  selectSearchResults,
  selectSearchLoading,
  selectSearchOptions,
};
